<script lang="ts" setup>
const { appURL } = useRuntimeConfig().public
const { locale } = useI18n()
const lang = computed(() => locale.value)
const target = ref()
const sticking = ref(false)

onMounted(() => {
  if (typeof window !== 'undefined') {
    const observer = new IntersectionObserver(
      ([entry]) => {
        sticking.value = !entry.isIntersecting
      },
      { threshold: 0.0 },
    )
    observer.observe(target.value)
  }
})
</script>

<template>
  <Html :lang="lang">
    <Body>
      <div
        ref="target"
        class="observer"
      />
      <nav
        :class="[
          'navigation',
          { sticking }
        ]"
      >
        <div class="navigation__content">
          <NuxtLink
            :to="`${appURL}${locale === 'en' ? '/en' : ''}`"
            title="Benefit Logo"
            aria-label="Benefit Logo"
          >
            <img
              :src="`${sticking ? '/logo.svg' : '/logo_white.svg'}`"
              :class="['navigation__logo', !sticking && 'navigation__logo--white']"
            >
          </NuxtLink>
        </div>
      </nav>

      <main class="main">
        <slot />
      </main>

      <UiFooter />
    </Body>
  </Html>
</template>

<style lang="scss" scoped>
.observer {
  position: absolute;
  top: 59rem;

  @include atM {
    top: 68rem;
  }
}

.navigation {
  position: fixed;
  z-index: 99;
  width: 100%;
  padding-top: 2rem;
  padding-bottom: 2rem;
  background-color: transparent;

  &.is-open,
  &.sticking {
    transition: all .5s ease-in-out;
  }

  &__content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    max-width: 156rem;
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 2.4rem;
    padding-left: 2.4rem;
  }

  &__logo {
    width: 9.6rem;
    height: auto;

    @include atM {
      width: 13.2rem;
    }

    &--white {
      position: relative;
      top: -1rem;
      left: -1rem;
      width: 11.6rem;

      @include atM {
        top: -2rem;
        left: -2rem;
        width: 17.2rem;
      }
    }
  }
}
</style>
